var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isStaging)?_c('v-container',{staticClass:"label",attrs:{"fluid":""}},[_vm._v("\n  STAGING ENV\n  "),_c('v-icon',{attrs:{"small":""}},[_vm._v("report_problem")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45723e4b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StagingLabel.vue
// module id = j7YE
// module chunks = 1